import Profile from './ProfileLayout';

export default Profile;
